/**
 * A chave do nome da amostra — a mesma comparação da API (`RN-207`).
 *
 * «AI-AM-01», «ai am 1» e «AI‑AM01» são a mesma amostra: a comparação
 * ignora caixa, acento, espaço, hífen e zero à esquerda. A API usa esta
 * conta para casar a linha da série com a amostra que a OS já tem
 * (`api/src/os/a-previsao-consome-o-escopo.ts`); o assistente de
 * recebimento usa a MESMA para sugerir a prevista pelo nome digitado
 * (`RN-220`, onda 251). Duas contas diferentes fariam a tela sugerir uma
 * ligação que a programação não reconhece — por isso o corpo é cópia
 * fiel da API, e o teste `238` confere que continuam iguais.
 */
export function chaveDoNome(s: string | null | undefined): string {
  if (!s) return '';
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ').trim().split(' ')
    .flatMap((t) => t.match(/[a-z]+|\d+/g) ?? [])
    .map((t) => (/^\d+$/.test(t) ? String(Number(t)) : t))
    .join('');
}
